var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-color-white full-height rounded-lg"},[(!_vm.authorized)?_c('RewardsBeforeAuth'):_c('RewardsAfterAuth')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }